import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqs } from '@/mocks/faqs';

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "爱情岛独家 - 最权威私密的独家内容体验平台",
  "description": "爱情岛独家为您提供最权威、最私密的独家内容体验，汇聚海量精选资源，带给您与众不同的专属享受。",
  "url": "https://aiqingdao.com",
  "isPartOf": {
    "@type": "WebSite",
    "name": "爱情岛独家",
    "url": "https://aiqingdao.com"
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <HeroSection />
      <CategorySection />
      <FeaturedArticles />
      <StatsSection />
      <TestimonialSection />
      <FAQSection />
      <CTASection />
    </>
  );
}